
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-118c9718\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"data\":\"@import \\\"~scss/variables\\\";\",\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BackButton.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BackButton.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-118c9718\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BackButton.vue"),
  /* scopeId */
  "data-v-118c9718",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/appComponents/oldWorkbench/attributePanel/BackButton.vue
// module id = 622
// module chunks = 0